import { render } from "./MixPrices.vue?vue&type=template&id=776d9e2e&ts=true"
import script from "./MixPrices.vue?vue&type=script&lang=ts"
export * from "./MixPrices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__